<template>

    <div class="container">

        <div class="block"></div>

        <div class="banner">

            <p class="text-baseRegular" v-show="!isDesktop">{{ $t('partial_fetch_banner_scan_done') }}</p>
            <p class="text-lRegular" v-show="isDesktop">{{ $t('partial_fetch_banner_scan_done') }}</p>

            <button @click="updateNewsletters(true)" class="text-baseMedium">{{ $t('partial_fetch_cta_refresh') }}</button>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'multi-scan-completed',

    methods: {
        ...Vuex.mapActions([
            'updateNewsletters'
        ])
    }

}
</script>

<style lang="scss" scoped>

.container {
    position: absolute;
    z-index: 1;
    bottom: 8px;
    left: 16px;
    right: 16px;
    color: $white;
    @media screen and (min-width: $above-tablet-length) {
        top: 16px;
        bottom: inherit;
    }

    .block {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0.1;
        z-index: 3;
    }


    .banner {
        z-index: 4;
        padding: 16px 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        text-align: start;
        background-color: $midnight;
        border-radius: 12px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05), 0 10px 15px 0 rgba(0, 0, 0, 0.1);

        position: fixed;
        bottom: 81px;
        left: 16px;
        right: 16px;

        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            top: 0;
            height: fit-content;
        }

        > p {
            margin: 0 8px;
        }

        > button {
            margin: 0 8px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 16px;
            border-radius: 32px;
            background-color: $aquamarine;
            color: $white;
        }
    }
}

</style>
